/* Gift page (adjustablechains.com), page behavior and cart. M13b theme port, 2026-09-30.
 *
 * Ported from prototype/lander.js (the gated prototype) with four deliberate differences, the same four the
 * live Addie lander script records:
 *
 * 1. NO HARDCODED PRICES OR VARIANT IDS. Every figure comes from #gbacGiftData, which Liquid renders from the
 *    live variants on each page view. The prototype's window.GIFT literal is gone.
 * 2. TOTALS SUM REAL PER-LINE PRICES for the finishes actually chosen, rather than reading one typed tier total.
 * 3. THE CART IS REAL. It posts to /cart/add.js?gbac=1, the whitelist the fetch shim in layout/theme.liquid
 *    requires (a plain POST to /cart/add is swallowed and answered with a synthetic empty cart), and it checks
 *    the RESULT, not just the HTTP status.
 * 4. The Shop Pay button adds the same lines, then opens checkout, where Shop Pay is offered.
 */
(function () {
  'use strict';
  var dataEl = document.getElementById('gbacGiftData');
  if (!dataEl) return;
  var G;
  try { G = JSON.parse(dataEl.textContent); } catch (e) {
    console.error('[gbac-gift] could not parse #gbacGiftData; buy box disabled', e);
    return;
  }
  var FREE_SHIP = (Number(G.freeShippingCents) || 5000) / 100;
  var fmt = function (n) { return '$' + n.toFixed(2); };
  function pill(p, w) { return Math.floor((1 - p / w) * 100) + '% off'; }
  var tiers = [].slice.call(document.querySelectorAll('#tiers .tier'));
  var pcards = [].slice.call(document.querySelectorAll('.pcard'));   // mid-page cards mirror the tiers, same order
  if (!tiers.length) return;
  var start = 0; G.tiers.forEach(function (t, i) { if (tiers[i] && tiers[i].classList.contains('on')) start = i; });
  var state = { tier: start, finish: G.finishes[0], picks: [G.finishes[0], G.finishes[1] || G.finishes[0]] };
  function slots() { var t = G.tiers[state.tier]; return t.n ? t.n : 1; }
  // finish per cart slot: slot 0 is always the swatch finish; slot 1 exists only on the Two gifts tier
  function finishFor(i) { return i === 0 ? state.finish : state.picks[i]; }
  function lineFinish(t, i) { return t.n ? finishFor(i) : state.finish; }
  function payload() {
    var t = G.tiers[state.tier], items = [];
    t.lines.forEach(function (k, i) {
      var u = G.units[k], f = lineFinish(t, i);
      items.push({ id: +u.variants[f], quantity: 1, handle: u.handles[f], available: !!u.available[f] });
    });
    return items;
  }
  function selectRow(i, idp, label) {
    return '<span class="pickrow"><span>' + label + '</span><select data-slot="' + i + '" id="' + idp + (i + 1) + '" aria-label="' + label + ' finish">'
      + G.finishes.map(function (f) { return '<option' + (f === finishFor(i) ? ' selected' : '') + '>' + f + '</option>'; }).join('') + '</select></span>';
  }
  function buildPickers() {
    document.querySelectorAll('#tiers .pickrows').forEach(function (box) {
      var n = +box.dataset.n, html = ''; for (var i = 0; i < n; i++) html += selectRow(i, 'f' + n + '_', 'Gift ' + (i + 1));
      box.innerHTML = html; box.addEventListener('click', function (e) { e.stopPropagation(); });
    });
  }

  function quote(i) {
    var t = G.tiers[i], p = 0, w = 0;
    t.lines.forEach(function (k, j) { var u = G.units[k], f = lineFinish(t, j); p += Number(u.prices[f]); w += Number(u.was[f]); });
    return { p: Math.round(p * 100) / 100, w: Math.round(w * 100) / 100 };
  }

  function midSelect() {
    var mid = document.getElementById('midPicks'), n = slots(), html = '';
    if (!mid) return;
    for (var i = 0; i < n; i++) html += selectRow(i, 'm', n > 1 ? 'Gift ' + (i + 1) : 'Finish');
    mid.innerHTML = html;
    var first = mid.querySelector('select'); first.id = 'mFinish';
    document.getElementById('midPickLbl').textContent = n > 1 ? 'Her finishes' : 'Her finish';
    bindAll();
  }
  function bindAll() {
    document.querySelectorAll('.pickrows select, #midPicks select').forEach(function (sel) {
      if (sel.dataset.bound) return; sel.dataset.bound = '1';
      sel.addEventListener('change', function () { var i = +sel.dataset.slot; if (i === 0) setFinish(sel.value); else { state.picks[i] = sel.value; sync(); render(); } });
    });
  }
  function sync() {
    document.querySelectorAll('.pickrows select, #midPicks select').forEach(function (sel) { var v = finishFor(+sel.dataset.slot); if (sel.value !== v) sel.value = v; });
  }
  function setText(id, s) { var el = document.getElementById(id); if (el) el.textContent = s; }

  function render() {
    var t = G.tiers[state.tier], q = quote(state.tier);
    setText('hdNow', fmt(q.p));
    setText('hdWas', fmt(q.w));
    setText('hdPill', pill(q.p, q.w));
    setText('hdFor', t['for']);
    var label = t.atc + ' · ' + fmt(q.p);
    setText('atcLabel', label);
    setText('atcLabel2', label);
    var sp = document.getElementById('stickyPrice'); if (sp) sp.innerHTML = fmt(q.p) + '<s>' + fmt(q.w) + '</s>';
    setText('mpTotal', fmt(q.p));
    setText('mpWas', fmt(q.w));
    setText('mpShip', q.p >= FREE_SHIP ? 'You have unlocked FREE SHIPPING' : 'Add ' + fmt(FREE_SHIP - q.p) + ' more for FREE SHIPPING');
    // what is in the cart, in words, so a total never carries a line she cannot see
    var words = t.lines.map(function (k, i) { var f = lineFinish(t, i); return G.units[k].label + ' (' + f + ') ' + fmt(Number(G.units[k].prices[f])); }).join(' + ');
    if (t.lines.length > 1) words = t.lines.length + ' items in your cart: ' + words;
    var pl = JSON.stringify(payload().map(function (x) { return { id: x.id, quantity: x.quantity, handle: x.handle }; }));
    ['atc', 'atc2'].forEach(function (id) { var b = document.getElementById(id); if (b) b.dataset.payload = pl; });
    setText('atcBreak', words);
    setText('mpBreak', words);
  }

  var swatches = [].slice.call(document.querySelectorAll('.sw'));
  function setFinish(f) {
    state.finish = f;
    swatches.forEach(function (x) { x.setAttribute('aria-pressed', x.dataset.finish === f); });
    setText('finishName', f);
    var img = document.getElementById('mainImg');
    if (img && G.finishImgs[f]) { img.srcset = (function(u){return [360,540,720].map(function(w){return u+(u.indexOf('?')>-1?'&':'?')+'width='+w+' '+w+'w';}).join(', ');})(G.finishImgs[f]); img.src = G.finishImgs[f]; img.alt = 'The Addie chain and Brilliant CZ Solitaire Pendant in ' + f.toLowerCase(); }
    sync();
    render();
  }

  function setTier(i) {
    state.tier = i;
    tiers.forEach(function (x, j) { x.classList.toggle('on', j === i); x.querySelector('input').checked = (j === i); });
    pcards.forEach(function (c, j) { c.classList.toggle('on', j === i); });
    midSelect();
    render();
  }
  tiers.forEach(function (t, i) { t.addEventListener('click', function () { setTier(i); }); });
  swatches.forEach(function (b) {
    b.addEventListener('click', function () {
      setFinish(b.dataset.finish);
      var tr = document.getElementById('track'), mi = document.getElementById('mainImg'); if (tr) { var si = mi ? [].indexOf.call(tr.children, mi.closest('.slide')) : 0; tr.scrollTo({ left: tr.clientWidth * Math.max(0, si), behavior: 'smooth' }); }
    });
  });
  pcards.forEach(function (c, i) {
    function pick() { setTier(i); }
    c.addEventListener('click', pick);
    c.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
  });

  // gallery (mobile carousel; on desktop every photo is shown)
  var track = document.getElementById('track'), thumbs = document.querySelectorAll('.thumbs button');
  if (track) {
    thumbs.forEach(function (b, i) { b.addEventListener('click', function () { track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); }); });
    track.addEventListener('scroll', function () { var i = Math.round(track.scrollLeft / track.clientWidth); thumbs.forEach(function (b, j) { b.setAttribute('aria-current', j === i); }); }, { passive: true });
  }

  // carousels (arrows are the controls; dots only show position)
  document.querySelectorAll('.carousel').forEach(function (car) {
    var tr = car.querySelector('.ctrack'), sl = car.querySelectorAll('.cslide'), dots = car.querySelectorAll('.cdot');
    var prev = car.querySelector('.prev'), next = car.querySelector('.next');
    if (!tr || !prev || !next) return;
    function go(i) { i = Math.max(0, Math.min(sl.length - 1, i)); tr.scrollTo({ left: sl[i].offsetLeft - tr.offsetLeft, behavior: 'smooth' }); }
    function cur() { var x = tr.scrollLeft, b = 0, d = 1e9; sl.forEach(function (s, i) { var k = Math.abs(s.offsetLeft - tr.offsetLeft - x); if (k < d) { d = k; b = i; } }); return b; }
    prev.addEventListener('click', function () { go(cur() - 1); });
    next.addEventListener('click', function () { go(cur() + 1); });
    tr.addEventListener('scroll', function () { var c = cur(); dots.forEach(function (d, i) { d.setAttribute('aria-current', i === c); }); }, { passive: true });
  });

  /* ---------- the real cart ---------- */
  var toast = document.getElementById('toast'), tt;
  function say(msg) {
    if (!toast) return;
    toast.textContent = msg; toast.classList.add('show');
    clearTimeout(tt); tt = setTimeout(function () { toast.classList.remove('show'); }, 3200);
  }
  function lineItems() {
    /* Aggregate by variant: two gifts in one finish post as quantity 2, which is what the cart would merge
       them into anyway. Two different finishes post as two lines. */
    var byId = {}, order = [], blocked = false;
    payload().forEach(function (x) {
      if (!x.available || !x.id) { blocked = true; return; }
      if (!byId[x.id]) { byId[x.id] = 0; order.push(x.id); }
      byId[x.id] += 1;
    });
    if (blocked) return [];
    return order.map(function (id) { return { id: id, quantity: byId[id] }; });
  }
  var adding = false;
  function addToCart(btn, then) {
    if (adding) return;
    var items = lineItems();
    if (!items.length) { say('Sorry, that finish is not available right now.'); return; }
    adding = true;
    if (btn) btn.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js?gbac=1', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json().then(function (body) { return { ok: res.ok, body: body }; });
    }).then(function (r) {
      if (!r.ok) throw new Error((r.body && (r.body.description || r.body.message)) || 'add failed');
      var got = (r.body && r.body.items) || [];
      if (!got.length) throw new Error('the cart came back empty; the add did not take');
      var want = items.reduce(function (a, x) { return a + x.quantity; }, 0);
      var have = got.reduce(function (a, x) { return a + (x.quantity || 0); }, 0);
      if (have !== want) console.warn('[gbac-gift] asked for ' + want + ' items, cart reported ' + have);
      document.dispatchEvent(new CustomEvent('gbac:gift:added', { detail: { items: got } }));
      if (then) { then(); return; }
      say('Added to your cart.');
      if (typeof window.monster_refresh === 'function') window.monster_refresh();
    }).catch(function (err) {
      console.error('[gbac-gift] add to cart failed', err);
      say('Sorry, that did not go through. Please try again.');
    }).then(function () {
      adding = false;
      if (btn) btn.removeAttribute('aria-busy');
    });
  }
  ['atc', 'atc2'].forEach(function (id) {
    var b = document.getElementById(id);
    if (b) b.addEventListener('click', function () { addToCart(b); });
  });
  var shoppay = document.querySelector('.shoppay');
  if (shoppay) shoppay.addEventListener('click', function () { addToCart(shoppay, function () { window.location.href = '/checkout'; }); });

  // sticky bar: state reads position every frame, so an instant jump cannot leave it stale
  var sticky = document.getElementById('sticky'), atc = document.getElementById('atc'), queued = false;
  var sbtn = document.getElementById('stickyBtn');
  if (sbtn) sbtn.addEventListener('click', function () { var b = document.getElementById('buy'); if (b) b.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
  function syncSticky() { queued = false; if (!sticky || !atc) return; var show = atc.getBoundingClientRect().bottom < 0; sticky.classList.toggle('show', show); sticky.setAttribute('aria-hidden', !show); }
  function queueSticky() { if (queued) return; queued = true; requestAnimationFrame(syncSticky); }
  window.addEventListener('scroll', queueSticky, { passive: true });
  window.addEventListener('resize', queueSticky);

  buildPickers();
  bindAll();
  midSelect();
  syncSticky();
  setFinish(state.finish);
  setTier(state.tier);
})();
